import { spacing_s, spacing_xs, white_smoke } from "../../StyleHelpers";
import styled, { css } from "styled-components/native";
import { formatDate, formatHoursAndMinutesFromToday, globalAny } from "../../utils/Utils";
import { View, Text } from "react-native";

interface Props {
	rating?: string;
	genres?: any;
	isRent?: boolean;
	expiryDate?: any;
	isNarrow?: boolean;
}

const StyledGenres = styled.View<any>`
	width: 100%;
	height: 46px;
	color: white;
	flex-direction: row;
	align-items: center;
	${(props) =>
		!props.isNarrow &&
		css`
			margin: 20px 0 ${spacing_s} 0;
		`}
`;

const StyledGenresContainer = styled.View<any>`
	background: rgba(255, 255, 255, 0.1);
	padding: ${(props) => (props.isNarrow ? "0.375rem 0.5rem" : spacing_xs)};
	border-radius: 4px;
	margin: 0 ${spacing_xs} 0 ${spacing_xs};
`;

const StyledText = styled.Text<any>`
	font-size: ${(props) => (props.isNarrow ? "0.875rem" : "1.125rem")};
	color: ${white_smoke};
`;

const StyledRatingContainer = styled.View<any>`
	background: rgba(0, 0, 0, 0.5);
	padding: ${(props) => (props.isNarrow ? "0.375rem 0.5rem" : spacing_xs)};
	border-radius: 4px;
	margin: 0 ${spacing_xs} 0 0;
	border-width: 2px;
	border-width: 1px;
	border-style: solid;
	border-color: white;
	align-items: center;
	text-align: center;
	color: white;
	font-size: ${(props) => (props.isNarrow ? "0.875rem" : "1.125rem")};
`;

const StyledProfileContainer = styled.Text<any>`
	background: rgba(0, 0, 0, 0.5);
	padding: ${(props) => (props.isNarrow ? "0.375rem 0.5rem" : spacing_xs)};
	border-radius: 4px;
	width: 60px;
	align-items: center;
	text-align: center;
	margin: 0 ${spacing_xs} 0 ${spacing_xs};
	color: white;
	font-size: ${(props) => (props.isNarrow ? "0.875rem" : "1.125rem")};
`;

const StyledExpiryContainer = styled.View`
	display: flex;
	align-items: flex-start;
	align-content: flex-start;
	gap: 8px;
	align-self: stretch;
	flex-wrap: wrap;
	margin-bottom: 16px;
`;

const StyledExpiryText = styled.Text`
	background: rgba(72, 28, 40, 0.5);
	border-radius: 4px;
	color: white;
	font-size: 18px;
	font-style: normal;
	font-weight: 500;
	line-height: 20px;
	display: flex;
	padding: 6px 8px;
	align-items: flex-start;
	white-space: nowrap;
	gap: 10px;
`;

const GenresComponent = (props: Props) => {
	const wording = {
		rentExpires: globalAny.language.rent_expires,
		rentViewingExpires: globalAny.language.rental_time_remaining,
		viewingExpires: globalAny.language.viewing_expires,
	};

	const onViewingExpires = (expiryDate: any) => {
		let date = new Date(new Date().toUTCString());
		const convertToDate = new Date(expiryDate.utcExpiryDate);
		let viewingExpiry = false;
		if (date.getMonth() === convertToDate.getMonth()) {
			viewingExpiry = 0 === date.getDate() - convertToDate.getDate();
			return { viewingExpiry: viewingExpiry, newDateFormat: formatDate(convertToDate) };
		}
		return { viewingExpiry: viewingExpiry, newDateFormat: formatDate(convertToDate) };
	};

	const formatExpiry = (expiryDate: any) => {
		let expiryTime;
		let hours;
		let minutes;
		const expiry = onViewingExpires(expiryDate);

		if (expiryDate?.ownershipExpiryHoursRemaining || expiryDate?.ownershipExpiryMinutesRemaining) {
			hours = Number(expiryDate?.ownershipExpiryHoursRemaining).toString();
			minutes = Number(expiryDate?.ownershipExpiryMinutesRemaining).toString();

			return wording.rentViewingExpires.replace("%1s", hours).replace("%2s", minutes);
		} else if (!expiryDate?.ownershipExpiryHoursRemaining && !expiryDate?.ownershipExpiryMinutesRemaining && expiry.viewingExpiry) {
			expiryTime = formatHoursAndMinutesFromToday(expiryDate.utcExpiryDate);

			return wording.rentViewingExpires.replace("%1s", expiryTime.hours).replace("%2s", expiryTime.minutes);
		} else {
			return `${wording.rentExpires} ${expiry.newDateFormat === "NaN/NaN/NaN" ? "" : expiry.newDateFormat}`;
		}
	};

	return (
		<>
			{/* @ts-ignore */}
			<StyledGenres isNarrow={props.isNarrow}>
				{/* @ts-ignore */}
				{props?.rating ? (
					<StyledRatingContainer isNarrow={props.isNarrow}>
						<StyledText>{props?.rating}</StyledText>
					</StyledRatingContainer>
				) : (
					<></>
				)}
				{/* @ts-ignore */}
				{props?.rating ? <StyledProfileContainer isNarrow={props.isNarrow}>HD</StyledProfileContainer> : <></>}
				{props?.genres?.map((item: any) => {
					return (
						//@ts-ignores
						<StyledGenresContainer isNarrow={props.isNarrow} key={`genre-component-${item}`}>
							<View>
								<Text>
									{/* @ts-ignores */}
									<StyledText isNarrow={props.isNarrow}>{item}</StyledText>
								</Text>
							</View>
						</StyledGenresContainer>
					);
				})}
			</StyledGenres>

			{props?.isRent ? (
				// @ts-ignore
				<StyledExpiryContainer>
					{/* @ts-ignore */}
					<StyledExpiryText>{formatExpiry(props?.expiryDate)}</StyledExpiryText>
				</StyledExpiryContainer>
			) : (
				<></>
			)}
		</>
	);
};

export default GenresComponent;
